module.exports = __webpack_public_path__ + "static/media/4 1 Skrivehastighet Intro.dc70551c.m4a";